module.exports = __webpack_public_path__ + "static/img/chuntianbaihe.2419e5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/chuntianbaihe.png
// module id = 6knC
// module chunks = 1